
const useQuotes = {
    message : "En Afrique, un Blanc qui adresse la parole à un Noir n'a plus la condescendance raciste des colonisateurs d'antan ; désormais c'est bien plus violent. Désormais, il a le regard apitoyé du prêtre qui administre l'extrême-onction à un condamné à mort. ",
    name : 'Frédéric Beigbeder',
    date : '1965'
}

export default useQuotes